module.exports = __webpack_public_path__ + "img/2.9dd27ee1.png";